var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Shop',{ref:"shop",attrs:{"id":_vm.$route.params.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }